import { useQuery } from 'data-fetching-client';
import { GET_FOLDER } from '../queries/getFolder';
export const useFolderQuery = folderId => useQuery(GET_FOLDER, {
  variables: {
    folderId
  },
  skip: !folderId
});